import SubscribeForm from "../SubscribeForm";

export function WorkshopOptions() {
  return (
    <section
      id="workshop-options"
      data-testid="vbw-workshop-options-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[64px] md:pt-[88px] pb-[64px] md:pb-[88px] reveal">
        <div className="max-w-2xl mx-auto text-center mb-[52px] md:mb-[64px]">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Workshop Options
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[50px] leading-[1.1] tracking-tight text-[#1C1917] mb-6">
            Choose the experience that&rsquo;s right for you.
          </h2>
          <p className="text-[20px] md:text-[22px] leading-relaxed text-[#57534E]">
            Whether you&rsquo;re looking for a gentle place to begin or more
            time to explore what matters most, both experiences are designed
            to help you reconnect with yourself and create a Vision Book
            you&rsquo;ll continue returning to long after the workshop ends.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 max-w-3xl mx-auto">
          <div data-testid="vbw-option-workshop" className="text-left">
            <p className="text-[20px] md:text-[22px] text-[#1C1917] font-medium">
              Vision Book Workshop
            </p>
            <p className="font-display text-2xl md:text-3xl text-[#159E9A] mt-1 mb-3">
              $36
            </p>
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
              A guided introduction to the Blueprint4Joy® Vision Book
              process.
            </p>
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed mt-3">
              Perfect if you&rsquo;re ready to begin listening again and want
              dedicated time to reconnect with what matters most.
            </p>
          </div>
          <div data-testid="vbw-option-experience" className="text-left">
            <p className="text-[20px] md:text-[22px] text-[#1C1917] font-medium">
              3-Day Vision Book Experience
            </p>
            <p className="font-display text-2xl md:text-3xl text-[#159E9A] mt-1 mb-3">
              $72
            </p>
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
              Includes the Vision Book Workshop plus Friday and Saturday
              sessions for participants who&rsquo;d like additional time to
              reflect, create and continue the experience.
            </p>
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed mt-3">
              Designed for those wanting deeper clarity without feeling
              rushed.
            </p>
          </div>
        </div>

        <div className="max-w-xl mx-auto text-center mt-[56px] md:mt-[72px]">
          <p className="text-[20px] md:text-[22px] leading-relaxed text-[#1C1917] font-medium mb-1">
            This month&rsquo;s workshop is full.
          </p>
          <div className="text-lg md:text-xl leading-relaxed text-[#57534E] space-y-1 mb-8">
            <p>
              Be the first to know when registration opens for{" "}
              <span className="text-[#1C1917] font-medium">
                next month&rsquo;s Vision Book Workshop.
              </span>
            </p>
            <p>
              Vision Book Workshops typically begin the{" "}
              <span className="text-[#1C1917] font-medium">
                third Thursday of each month
              </span>
              .
            </p>
            <p>
              Friday and Saturday sessions are available for those who
              choose the extended experience.
            </p>
          </div>

          <div className="max-w-sm mx-auto">
            <SubscribeForm
              source="vision_book_workshop"
              buttonLabel="Notify Me"
              placeholder="Email Address"
              withName={false}
              testIdPrefix="vbw-options-subscribe"
              theme="light"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
